import { OrderTemplateDto, OrderTemplateItemDto } from '@eurogast/hub-client-typescript';

export abstract class OrderTemplateDeserializer {
  public static parseOrderTemplateList(orderTemplateItem: string): OrderTemplateDto[] {
    if (!orderTemplateItem) {
      return [];
    }
    const m: Map<string, string> = new Map<string, string>();
    const result: OrderTemplateDto[] = [];
    orderTemplateItem.split(';;').forEach((s) => {
      const parts = s.split('::');
      if (parts[0] !== null && parts[0] !== '') {
        result.push({
          id: Number(parts[0]),
          name: parts[1],
          orderTemplateItems: OrderTemplateDeserializer.parseItemsArray(parts[2])
        });
      }
    });
    return result;
  }

  private static parseItemsArray(source: string): OrderTemplateItemDto[] {
    if (!source || source === '[]') {
      return [];
    } else if (source.startsWith('[') && source.endsWith(']')) {
      return source.slice(1, -1).split('||').map((item) => this.getOrderTemplateItemWithSku(item));
    }
    throw Error(`Expected array, but got ${source}`);
  }

  private static getOrderTemplateItemWithSku(sku): OrderTemplateItemDto {
    return {productSku: sku};
  }

}
